__turbopack_context__.v({
  "description": "SatributeCard-module__fZrBua__description",
  "emoji": "SatributeCard-module__fZrBua__emoji",
  "iconContainer": "SatributeCard-module__fZrBua__iconContainer",
  "root": "SatributeCard-module__fZrBua__root",
});
